export default __webpack_public_path__ + "0892550675ab52160876606ab9d623c9.svg";